var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { when } from 'lit/directives/when.js';
import { translate } from '../utilities/translate';
export const SdsLoadMoreBase = (Base) => {
    var _SdsLoadMoreBaseType_addLoadMore_accessor_storage, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, _SdsLoadMoreBaseType_loadedCount_accessor_storage, _SdsLoadMoreBaseType_count_accessor_storage;
    class SdsLoadMoreBaseType extends Base {
        constructor() {
            super(...arguments);
            _SdsLoadMoreBaseType_addLoadMore_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_addLoadAll_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_disableLoadAll_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_loadedCount_accessor_storage.set(this, void 0);
            _SdsLoadMoreBaseType_count_accessor_storage.set(this, void 0);
        }
        static get properties() {
            return {
                addLoadMore: { type: Boolean, attribute: 'add-load-more' },
                addLoadAll: { type: Boolean, attribute: 'add-load-all' },
                disableLoadAll: { type: Boolean, attribute: 'disable-load-all' },
                loadedCount: { type: Number, attribute: 'loaded-count' },
                count: { type: Number, attribute: 'count' },
            };
        }
        /**
         * This attribute must draw Load More button if true.
         * @attr
         */
        get addLoadMore() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_addLoadMore_accessor_storage, "f"); }
        set addLoadMore(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_addLoadMore_accessor_storage, value, "f"); }
        /**
         * This attribute must draw Load All button if true.
         * @attr
         */
        get addLoadAll() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, "f"); }
        set addLoadAll(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_addLoadAll_accessor_storage, value, "f"); }
        /**
         * This attribute must disable Load All button if true.
         * @attr
         */
        get disableLoadAll() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, "f"); }
        set disableLoadAll(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_disableLoadAll_accessor_storage, value, "f"); }
        /**
         * This attribute represents the number of loaded items.
         * @attr
         */
        get loadedCount() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_loadedCount_accessor_storage, "f"); }
        set loadedCount(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_loadedCount_accessor_storage, value, "f"); }
        /**
         * This attribute represents total count of items in this table.
         * @attr
         */
        get count() { return __classPrivateFieldGet(this, _SdsLoadMoreBaseType_count_accessor_storage, "f"); }
        set count(value) { __classPrivateFieldSet(this, _SdsLoadMoreBaseType_count_accessor_storage, value, "f"); }
        renderInfo() {
            return html `
                <div class="sds-load-more__loaded-info">
                    <span>${this.loadedCount}</span>
                    <bdi>${translate('sds.from')}</bdi>
                    ${this.count}
                </div>
            `;
        }
        renderButtons() {
            return html ` <div class="sds-load-more__row">
                ${when(this.addLoadMore, () => html `
                        <sds-button
                            class="sds-load-more__action"
                            @click="${() => this.dispatchLoadMore()}"
                            label="${translate('sds.load_more')}"
                            size="lg"
                            type="tertiary"
                            icon="reset"
                        ></sds-button>
                    `, () => html ``)}
                ${when(this.addLoadAll && !this.disableLoadAll, () => html `
                        <sds-button
                            class="sds-load-more__action"
                            @click="${() => this.dispatchLoadAll()}"
                            label="${translate('sds.load_all')}"
                            size="lg"
                            type="tertiary"
                            icon="refresh"
                        ></sds-button>
                    `, () => html ``)}
                ${when(this.disableLoadAll && this.addLoadAll, () => html `
                        <sds-button
                            disabled
                            class="sds-load-more__action"
                            @click="${() => this.dispatchLoadMore()}"
                            label="${translate('sds.load_all')}"
                            size="lg"
                            type="tertiary"
                            icon="refresh"
                        ></sds-button>
                        <div class="sds-load-more__message">
                            ${translate('sds.disabled_load_all')}
                        </div>
                    `, () => html ``)}
            </div>`;
        }
        dispatchLoadMore() {
            this.dispatchEvent(new CustomEvent(SdsLoadMoreBaseType.LOAD_MORE_CLICKED_EVENT, {
                detail: {
                    loadedCount: this.loadedCount,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchLoadAll() {
            this.dispatchEvent(new CustomEvent(SdsLoadMoreBaseType.LOAD_ALL_CLICKED_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
    }
    _SdsLoadMoreBaseType_addLoadMore_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_addLoadAll_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_disableLoadAll_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_loadedCount_accessor_storage = new WeakMap(), _SdsLoadMoreBaseType_count_accessor_storage = new WeakMap();
    SdsLoadMoreBaseType.LOAD_MORE_CLICKED_EVENT = 'sds.load-more.clicked';
    SdsLoadMoreBaseType.LOAD_ALL_CLICKED_EVENT = 'sds.load-all.clicked';
    return SdsLoadMoreBaseType;
};
